import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/gifts/birthday/$offerId")({
  component: lazyRouteComponent(() => import("./-pages/account.gifts.birthday.$offerId")),
});
